const FULL_WIDTH_SPAN = 12;

/**
 * Ubicación de un campo en la grilla de 12 columnas de `DrawerFormSection` (patrón de Finanzas).
 * @param {number} md Columnas que ocupa en escritorio (1 a 12).
 * @returns {Object} `sx` con `gridColumn` responsive.
 */
export const drawerFieldSpan = (md) => ({
  gridColumn: {
    xs: '1',
    sm: md === FULL_WIDTH_SPAN ? '1 / -1' : 'span 1',
    md: `span ${md}`,
  },
});
